const shortName = ['อ.1', 'อ.2', 'อ.3', 'ป.1', 'ป.2', 'ป.3', 'ป.4', 'ป.5', 'ป.6', 'ม.1', 'ม.2', 'ม.3', 'ม.4', 'ม.5', 'ม.6']
const fullName = [
    'อนุบาล 1', 'อนุบาล 2', 'อนุบาล 3', 'ประถมศึกษาปีที่ 1', 'ประถมศึกษาปีที่ 2', 'ประถมศึกษาปีที่ 3', 'ประถมศึกษาปีที่ 4', 'ประถมศึกษาปีที่ 5',
    'ประถมศึกษาปีที่ 6', 'มัธยมศึกษาปีที่ 1', 'มัธยมศึกษาปีที่ 2', 'มัธยมศึกษาปีที่ 3', 'มัธยมศึกษาปีที่ 4', 'มัธยมศึกษาปีที่ 5', 'มัธยมศึกษาปีที่ 6'
]

const kindergarten = [99, 98, 97]
const primary = [1, 2, 3, 4, 5, 6]
const secondary = [7, 8, 9, 10, 11, 12]

export function getFullGrade(year, locale = 'th') {
    let gradeString = ''
    if (kindergarten.includes(year)) {
        gradeString = locale == 'th' ? 'อนุบาล' : 'Kindergarten'
    } else if (primary.includes(year)) {
        gradeString = locale == 'th' ? 'ประถมศึกษาปีที่' : 'Primary'
    } else if (secondary.includes(year)) {
        gradeString = locale == 'th' ? 'มัธยมศึกษาปีที่' : 'Secondary'
    }

    return gradeString
}

export function getShortGrade(year, locale = 'th') {
    let gradeString = ''
    if (kindergarten.includes(year)) {
        gradeString = locale == 'th' ? 'อ.' : 'K.'
    } else if (primary.includes(year)) {
        gradeString = locale == 'th' ? 'ป.' : 'P.'
    } else if (secondary.includes(year)) {
        gradeString = locale == 'th' ? 'ม.' : 'S.'
    }

    return gradeString
}

export function getStudentYear(year) {
    let yearString = ''
    if (kindergarten.includes(year)) {
        if (year === 99) {
            yearString = '1'
        } else if (year === 98) {
            yearString = '2'
        } else {
            yearString = '3'
        }
    } else if (primary.includes(year)) {
        yearString = `${year}`
    } else if (secondary.includes(year)) {
        yearString = `${year - 6}`
    }

    return yearString
}

export function getFullStudentYear(year) {
    let yearString = String
    if (kindergarten.includes(year)) {
        if (year === 99) {
            yearString = fullName[0]
        } else if (year === 98) {
            yearString = fullName[1]
        } else {
            yearString = fullName[2]
        }
    } else {
        const index = year + 2
        yearString = fullName[index]
    }

    return yearString
}

export function getShortStudentYear(year) {
    let yearString = String
    if (kindergarten.includes(year)) {
        if (year === 99) {
            yearString = shortName[0]
        } else if (year === 98) {
            yearString = shortName[1]
        } else {
            yearString = shortName[2]
        }
    } else {
        const index = year + 2
        yearString = shortName[index]
    }

    return yearString
}

export function studentClassroomToString(year, room) {
    return `${this.getShortStudentYear(year)}/${room}`
}

export function getStudentLevel (level, lang) {
    let levelText = ''
    if (level === 'HIGH') {
        if (lang === 'th') {
            levelText = 'มัธยมศึกษาตอนปลาย'
        } else {
            levelText = 'HIGH SCHOOL'
        }
    } else if (level === 'MIDDLE') {
        if (lang === 'th') {
            levelText = 'มัธยมศึกษาตอนต้น'
        } else {
            levelText = 'MIDDLE SCHOOL'
        }
    } else {
        if (lang === 'th') {
            levelText = 'ประถมศึกษา'
        } else {
            levelText = 'PRIMARY SCHOOL'
        }
    }
    return levelText
}
